<script setup lang="ts">
import type { AccordionItemProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { AccordionItem, useForwardProps } from 'reka-ui';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<AccordionItemProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <AccordionItem
        v-slot="slotProps"
        data-slot="accordion-item"
        v-bind="forwardedProps"
        :class="props.class"
    >
        <slot v-bind="slotProps"></slot>
    </AccordionItem>
</template>
